import * as graphql from "../../../resolvers-types";
import { Icon } from "../../../resolvers-types";
// import { generateUID } from "../../library/utils";  // CRITICAL: DO NOT USE THIS FUNCTION IN THE LIBRARY, USE THE ONE BELOW

// import { randomFillSync } from "crypto";

export function generateUID() {
  return generateRandomString(10);
}

// function generateRandomString(length) {
//   const chars = "abcdefghijklmnopqrstuvwxyz0123456789";
//   // const chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
//   let result = "";
//   const array: Uint8Array = new Uint8Array(length);
//   randomFillSync(array);

//   for (let i = 0; i < length; i++) {
//     result += chars[array[i] % chars.length];
//   }

//   return result;
// }

export const generateRandomString = (length: number): string => {
  const chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  let result = "";
  const array: Uint8Array = new Uint8Array(length);

  if (typeof window !== "undefined" && window.crypto?.getRandomValues) {
    // Browser
    window.crypto.getRandomValues(array);
  } else {
    // Node.js (no `window`)
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const nodeCrypto = require("crypto");
    nodeCrypto.randomFillSync(array);
  }

  for (let i = 0; i < length; i++) {
    result += chars[array[i] % chars.length];
  }

  return result;
};

export const componentLibrary: graphql.ComponentLibrary = {
  __typename: "ComponentLibrary",
  Id: generateUID(),
  Name: "Components",
  Bindings: {
    Components:
      "State.Components?State.Components.map(function(c) \
      { ({__typename: 'LibraryItem', Id: c.Id,Name: c.Name, \
        Description: c.Description, \
        Category: c.Category, \
        Template: \
        { \
          __typename: 'Reference', \
          Id: uid(), \
          ReferenceType: 'Component', \
          ReferenceId: c.Id, \
          ReferenceSource: c.Source \
        } \
      }) }):[]",
  },

  Components: [],
};

export const controlLibrary: graphql.ComponentLibrary = {
  __typename: "ComponentLibrary",
  Id: generateUID(),
  Name: "Items",
  Components: [
    // {
    //   __typename: "LibraryItem",
    //   Id: generateUID(),
    //   Name: "Free Form Container",
    //   Icon: { IconName: "CropFreeOutlined" },
    //   Type: "Items",
    //   Description: "A description for SimpleContainer",
    //   Category: "Containers",
    //   SubCategory: "",
    //   InitialWidth: 5,
    //   InitialHeight: 25,
    //   Template: {
    //     __typename: "SimpleContainer",
    //     Id: generateUID(),
    //     Items: [],
    //     Layout: {
    //       __typename: "FreeFormLayout",
    //     },
    //   },
    // },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Vertical Container",
      Icon: { IconName: "aspect_ratio" } as Icon,
      Type: "Items",
      Description: "A description for FlexContainer",
      Category: "Containers",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "SimpleContainer",
        Id: generateUID(),
        Items: [],
        IgnoreLayout: true,
        Style: {
          display: "flex",
          flexDirection: "column",
          minWidth: "20px",
          minHeight: "20px",
        },
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Horizontal Container",
      Icon: { IconName: "aspect_ratio" } as Icon,
      Type: "Items",
      Description: "A description for FlexContainer",
      Category: "Containers",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "SimpleContainer",
        Id: generateUID(),
        Items: [],
        IgnoreLayout: true,
        Style: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          minWidth: "20px",
          minHeight: "20px",
        },
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Dialog",
      Icon: { IconName: "open_in_new" } as Icon,
      Type: "Items",
      Description: "A description for Dialog",
      Category: "Containers",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "Dialog",
        Id: generateUID(),
        ContentContainer: {
          __typename: "SimpleContainer",
          Id: generateUID(),
          Items: [],
          IgnoreLayout: true,
          Style: {
            display: "flex",
            flexDirection: "column",
            minWidth: "20px",
            minHeight: "20px",
          },
        },
        Style: {},
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Drawer",
      Icon: { IconName: "left_panel_open" },
      Type: "Items",
      Description: "A description for Drawer",
      Category: "Containers",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "Drawer",
        Id: generateUID(),
        Items: [],
        Style: {},
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Button",
      Icon: { IconName: "smart_button" } as Icon,
      Type: "Items",
      Description: "A description for Button",
      Category: "Controls",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        Id: generateUID(),
        __typename: "Button",
        Label: "Button",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Column",
      Icon: { IconName: "view_column" } as Icon,
      Type: "Items",
      Description: "A description for List Column",
      Category: "Controls",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        Id: generateUID(),
        __typename: "ListColumn",
        HeaderName: "New Column",
        Name: "NewColumn",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Label",
      Icon: { IconName: "abc" } as Icon,
      Type: "Items",
      Description: "A description for Label",
      Category: "Controls",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        Id: generateUID(),
        __typename: "Label",
        Value: "Label",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Link",
      Icon: { IconName: "link" } as Icon,
      Type: "Items",
      Description: "A description for Link",
      Category: "Controls",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        Id: generateUID(),
        __typename: "Link",
      },
    }, //
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Html",
      Icon: { IconName: "language" } as Icon,
      Type: "Items",
      Description: "A description for HTML",
      Category: "Controls",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        Id: generateUID(),
        Icon: { IconName: "language" },
        __typename: "Html",
        Value: "</b>Html<b>",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Audio Player",
      Icon: { IconName: "play_arrow" } as Icon,
      Type: "Items",
      Description: "A description for Audio Players",
      Category: "Controls",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        Id: generateUID(),
        Icon: { IconName: "language" },
        __typename: "AudioPlayer",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Markdown",
      Icon: { IconName: "description" } as Icon,
      Type: "Items",
      Description: "A description for Markdown",
      Category: "Controls",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        Id: generateUID(),
        Icon: { IconName: "language" },
        __typename: "Markdown",
        Value: "## Markdown",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Multi-Select",
      Icon: { IconName: "arrow_drop_down_circle" } as Icon,
      Type: "Items",
      Description: "A description for MultiSelect",
      Category: "Controls",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        Id: generateUID(),
        __typename: "MultiSelect",
        Label: "MultiSelect",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Checkbox",
      Icon: { IconName: "check_box" } as Icon,
      Type: "Items",
      Description: "A description for Checkbox",
      Category: "Controls",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        Id: generateUID(),
        __typename: "Checkbox",
        Label: "Checkbox",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Slider",
      Icon: { IconName: "linear_scale" } as Icon,
      Type: "Items",
      Description: "A description for Slider",
      Category: "Controls",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        Id: generateUID(),
        __typename: "Slider",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Switch",
      Icon: { IconName: "toggle_off" } as Icon,
      Type: "Items",
      Description: "A description for Switch",
      Category: "Controls",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        Id: generateUID(),
        __typename: "Switch",
        Label: "Label for Switch",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Input Field",
      Icon: { IconName: "crop_16_9" } as Icon,
      Type: "Items",
      Description: "A description for InputField",
      Category: "Controls",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        Id: generateUID(),
        __typename: "InputField",
        Label: "Label for InputField",
        Style: { margin: "0px", width: "100%" },
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Rich Text Editor",
      Icon: { IconName: "text_snippet" } as Icon,
      Type: "Items",
      Description: "A description for RichTextEditor",
      Category: "Controls",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        Id: generateUID(),
        __typename: "RichTextEditor",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Accordion",
      Icon: { IconName: "aspect_ratio" } as Icon,
      Type: "Items",
      Description: "A description for FlexContainer",
      Category: "Containers",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "AccordionLayout",
        Id: generateUID(),
        Groups: [
          {
            __typename: "AccordionGroup",
            Id: generateUID(),
            Label: `Accordion Group`,
            Header: {
              __typename: "SimpleContainer",
              Id: generateUID(),
              Items: [
                {
                  __typename: "Label",
                  Id: generateUID(),
                  Value: "Accordion Header",
                },
              ],
              IgnoreLayout: true,
              Style: {
                display: "flex",
                flexDirection: "column",
                minWidth: "20px",
                minHeight: "20px",
              },
            },
            Items: [
              {
                __typename: "SimpleContainer",
                Id: generateUID(),
                Items: [
                  {
                    __typename: "Label",
                    Id: generateUID(),
                  },
                ],
                IgnoreLayout: true,
                Style: {
                  display: "flex",
                  flexDirection: "column",
                  minWidth: "20px",
                  minHeight: "20px",
                },
              },
            ],
          },
        ],
        Style: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          minWidth: "20px",
          minHeight: "20px",
        },
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Date Picker",
      Icon: { IconName: "calendar_today" } as Icon,
      Type: "Items",
      Description: "A description for Date Picker",
      Category: "Controls",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        Id: generateUID(),
        __typename: "DatePicker",
        Label: "Date",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Time Picker",
      Icon: { IconName: "schedule" } as Icon,
      Type: "Items",
      Description: "A description for Time Picker",
      Category: "Controls",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        Id: generateUID(),
        __typename: "TimePicker",
        Label: "Time",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "TimeZone Picker",
      Icon: { IconName: "arrow_drop_down_circle" } as Icon,
      Type: "Items",
      Description: "A description for Date Picker",
      Category: "Controls",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        Id: generateUID(),
        __typename: "TimeZonePicker",
        Label: "Time Zone",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Assistant",
      Icon: { IconName: "psychology" } as Icon,
      Type: "Items",
      Description: "A description for Assistant",
      Category: "Controls",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        Id: generateUID(),
        __typename: "Assistant",
        Label: "Assistant",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Radio Group",
      Icon: { IconName: "radio_button_checked" } as Icon,
      Type: "Items",
      Description: "A description for RadioGroup",
      Category: "Controls",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        Id: generateUID(),
        __typename: "RadioGroup",
        MultiSelectPossibleValues: ["Option1", "Option2", "Option3"],
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Chip Group",
      Icon: { IconName: "splitscreen" },
      Type: "Items",
      Description: "A description for ChipGroup",
      Category: "Controls",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        Id: generateUID(),
        __typename: "ChipGroup",
        MultiSelectPossibleValues: ["Option1", "Option2", "Option3"],
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Avatar",
      Icon: { IconName: "account_circle" } as Icon,
      Type: "Items",
      Description: "A description for Image",
      Category: "Controls",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        Id: generateUID(),
        __typename: "Avatar",
      } as graphql.Avatar,
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Image",
      Icon: { IconName: "photo" } as Icon,
      Type: "Items",
      Description: "A description for Image",
      Category: "Controls",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        Id: generateUID(),
        __typename: "Image",
        // Width: "100%",
        // Height: "auto",
        Value: "communify-finance-logo.webp",
      } as graphql.Image,
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "File Upload",
      Icon: { IconName: "upload_file" } as Icon,
      Type: "Items",
      Description: "A description for FileUpload",
      Category: "Controls",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        Id: generateUID(),
        __typename: "FileUpload",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Document Viewer",
      Icon: { IconName: "find_in_page" } as Icon,
      Type: "Items",
      Description: "A description for DocumentViewer",
      Category: "Controls",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        Id: generateUID(),
        __typename: "DocumentViewer",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Tab Container",
      Icon: { IconName: "tab" } as Icon,
      Type: "Items",
      Description: "A description for TabContainer",
      Category: "Containers",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "TabContainer",
        Id: generateUID(),
        BoxStyle: { width: "100%" },
        Items: [
          {
            __typename: "TabItem",
            Id: generateUID(),
            Title: "Tab 1",
            Items: [
              {
                __typename: "SimpleContainer",
                Id: generateUID(),
                Items: [],
                IgnoreLayout: true,
                Style: {
                  display: "flex",
                  flexDirection: "column",
                  minWidth: "20px",
                  minHeight: "20px",
                },
              },
            ],
          },
          {
            __typename: "TabItem",
            Id: generateUID(),
            Title: "Tab 2",
            Items: [
              {
                __typename: "SimpleContainer",
                Id: generateUID(),
                Items: [],
                IgnoreLayout: true,
                Style: {
                  display: "flex",
                  flexDirection: "column",
                  minWidth: "20px",
                  minHeight: "20px",
                },
              },
            ],
          },
        ],
        Classes: ["tab-large"],
      },
    },

    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Repeater",
      Icon: { IconName: "auto_awesome_motion" } as Icon,
      Type: "Items",
      Description: "A description for Repeater",
      Category: "Containers",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "Repeater",
        Id: generateUID(),
        Variant: "Flex",
        Items: [
          {
            __typename: "SimpleContainer",
            Id: generateUID(),
            Items: [],
            IgnoreLayout: true,
            Style: {
              display: "flex",
              flexDirection: "column",
              minWidth: "20px",
              minHeight: "20px",
            },
          },
        ],
        Layout: {
          Id: generateUID(),
          __typename: "FlexLayout",
          Direction: "column",
        },
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Data Grid",
      Icon: { IconName: "table_chart" } as Icon,
      Type: "Items",
      Description: "Grid with groupping filtering",
      Category: "Containers",
      SubCategory: "Data",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "List",
        Id: generateUID(),
        ShowExport: true,
        ShowClearAllFilters: true,
        ShowFloatingFilter: true,
        ShowQuickFilter: true,
        Style: { width: "100%" },
        GridLayout: "normal",
        ListColumns: [
          {
            __typename: "ListColumn",
            Id: generateUID(),
            HeaderName: "Id",
            Name: "Id",
            IsPrimaryKey: true,
          },
          {
            __typename: "ListColumn",
            Id: generateUID(),
            HeaderName: "Name",
            Name: "Name",
          },
          {
            __typename: "ListColumn",
            Id: generateUID(),
            HeaderName: "Ticker",
            Name: "Ticker",
          },
          {
            __typename: "ListColumn",
            Id: generateUID(),
            HeaderName: "Quote",
            Name: "Quote",
          },
        ],
        Rows: [
          {
            Id: 1,
            Name: "NVIDIA",
            Ticker: "NVDA",
            Quote: 67.87,
            FileExtension: "pdf",
          },
          {
            Id: 2,
            Name: "Microsoft",
            Ticker: "MSFT",
            Quote: 152.17,
            FileExtension: "png",
          },
          {
            Id: 3,
            Name: "Apple",
            Ticker: "AAPL",
            Quote: 200.15,
            FileExtension: "docx",
          },
          {
            Id: 4,
            Name: "Meta",
            Ticker: "META",
            Quote: 537.95,
            FileExtension: "xlsx",
          },
        ],
        Items: [
          {
            __typename: "SimpleContainer",
            Id: "mi65126nd0",
            IgnoreLayout: true,
            Style: {
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              minHeight: "20px",
              flex: 1,
              justifyContent: "space-between",
            },
            Items: [
              {
                __typename: "ListExportButton",
                EnableCSV: true,
                EnableExcel: true,
                Id: generateUID(),
              },
              {
                __typename: "ListQuickFilter",
                Actions: [],
                Adornment: {
                  Position: "Start",
                  Icon: {
                    IconName: "Search",
                  },
                },
                Id: generateUID(),
              },
            ],
          },
        ],
      },
    },

    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Menu",
      Icon: { IconName: "menu" } as Icon,
      Type: "Items",
      Description: "Visible Menu",
      Category: "Containers",
      SubCategory: "Data",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "VisibleMenu",
        Id: generateUID(),
      },
    },

    // {
    //   __typename: "LibraryItem",
    //   Id: generateUID(),
    //   Name: "Data Grid",
    //   Icon: { IconName: "TableChartOutlined" },
    //   Type: "Items",
    //   Description: "A description for Data Grid",
    //   Category: "Container",
    //   SubCategory: "",
    //   InitialWidth: 5,
    //   InitialHeight: 25,
    //   Template: {
    //     __typename: "List",
    //     Id: generateUID(),
    //     ShowExport: true,
    //     ShowFilter: true,
    //     Style: { width: "100%" },
    //     ListColumns: [
    //       {
    //         __typename: "ListColumn",
    //         Id: generateUID(),
    //         HeaderName: "Id",
    //         Name: "Id",
    //         IsPrimaryKey: true,
    //       },
    //       {
    //         __typename: "ListColumn",
    //         Id: generateUID(),
    //         HeaderName: "Column 1",
    //         Name: "Column1",
    //       },
    //       {
    //         __typename: "ListColumn",
    //         Id: generateUID(),
    //         HeaderName: "Column 2",
    //         Name: "Column2",
    //       },
    //     ],
    //     Rows: [],
    //   },
    // },

    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Dynamic App",
      SerialNumber: "..",
      Icon: { IconName: "settings" } as Icon,
      Type: "Items",
      Description: "Dynamic App",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "dynamic-market-app",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Chart Basic - Stock",
      SerialNumber: "FMR.7319.M.01.STKBCH",
      Icon: { IconName: "show_chart" } as Icon,
      Type: "Items",
      Description: "Chart Basic - Stock",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "basic-chart",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "IFrame",
      Icon: { IconName: "photo" } as Icon,
      Type: "Items",
      Description: "IFrame",
      Category: "Containers",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "IFrame",
        Id: generateUID(),
        Width: "100%",
        Height: "500px",
        Style: {
          border: "none",
        },
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Sectors & Industries",
      SerialNumber: "FMR.7002.M.01.SCT&IND",
      Icon: { IconName: "factory" } as Icon,
      Type: "Items",
      Description: "Sectors & Industries",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "sector-and-industries",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Sectors & Industries - Comparison",
      SerialNumber: "FA.7002.C.01.MRK",
      Icon: { IconName: "factory" } as Icon,
      Type: "Items",
      Description: "Sectors & Industries - Comparison",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "sectors-industries-comparison",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Indices - List",
      Icon: { IconName: "leaderboard" } as Icon,
      Type: "Items",
      Description: "Indices - List",
      SerialNumber: "FMR.8104.M.01.INDXLST",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "indices",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Company Profile",
      SerialNumber: "FMR.7317.M.01.COPFL",
      Icon: { IconName: "account_circle" } as Icon,
      Type: "Items",
      Description: "Company Profile",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "stock-story-profile",
        Exchange: "NASQ",
        Symbol: "AAPL",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Stock Story - Dividends",
      SerialNumber: "FMM.7311.M.01.SSDIV",
      Icon: { IconName: "attach_money" } as Icon,
      Type: "Items",
      Description: "Fin Basic Chart",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "stock-story-dividends",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Stock Story - Performance",
      SerialNumber: "FMM.7307.M.01.SSPRF",
      Icon: { IconName: "query_stats" } as Icon,
      Type: "Items",
      Description: "Stock Story - Performance",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "stock-story-performance",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Stock Story - Earnings",
      SerialNumber: "FMM.7310.M.01.SSEARN",
      Icon: { IconName: "stacked_line_chart" } as Icon,
      Type: "Items",
      Description: "Stock Story - Earnings",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "stock-story-earnings",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Stock Story - Profitablility",
      SerialNumber: "FMM.7304.M.01.SSPRFIT",
      Icon: { IconName: "paid" } as Icon,
      Type: "Items",
      Description: "Fin Basic Chart",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "stock-story-profitability",
      },
    },
    // {
    //   __typename: "LibraryItem",
    //   Id: generateUID(),
    //   Name: "Fin Stock Story Outlook",
    //   Icon: { IconName: "BarChart" },
    //   Type: "Items",
    //   Description: "Fin Basic Chart",
    //   Category: "Market Apps",
    //   SubCategory: "",
    //   InitialWidth: 5,
    //   InitialHeight: 25,
    //   Template: {
    //     __typename: "FinApp",
    //     Id: generateUID(),
    //     Type: "stock-story-outlook",
    //   },
    // },
    // {
    //   __typename: "LibraryItem",
    //   Id: generateUID(),
    //   Name: "Fin Stock Story Peers News",
    //   Icon: { IconName: "BarChart" },
    //   Type: "Items",
    //   Description: "Fin Basic Chart",
    //   Category: "Market Apps",
    //   SubCategory: "",
    //   InitialWidth: 5,
    //   InitialHeight: 25,
    //   Template: {
    //     __typename: "FinApp",
    //     Id: generateUID(),
    //     Type: "stock-story-peers-news",
    //   },
    // },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Stock Story - Growth",
      Icon: { IconName: "trending_up" } as Icon,
      SerialNumber: "FMM.7308.M.01.SSGRW",
      Type: "Items",
      Description: "Stock Story - Growth",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "stock-story-growth",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Fin Stock Story Overvalued",
      Icon: { IconName: "waterfall_chart" } as Icon,
      Type: "Items",
      Description: "Fin Basic Chart",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "stock-story-overvalued",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Stock Story - Debt",
      SerialNumber: "FMM.7315.M.01.SSDBT",
      Icon: { IconName: "account_balance" } as Icon,
      Type: "Items",
      Description: "Stock Story - Debt",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "stock-story-debt",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Fin Stock Story Forecast",
      Icon: { IconName: "ssid_chart" } as Icon,
      Type: "Items",
      Description: "Fin Basic Chart",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "stock-story-forecast",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Stock Story - Portfolio Fit",
      SerialNumber: "FMM.7306.M.01.SSPRTFT",
      Icon: { IconName: "query_stats" } as Icon,
      Type: "Items",
      Description: "Stock Story - Portfolio Fit",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "stock-story-portfolio-fit",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Dynamic Video",
      Icon: { IconName: "live_tv" } as Icon,
      SerialNumber: "FMR.7903.M.01.DYNVID",
      Type: "Items",
      Description: "Dynamic Video",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "dv-market-update",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Watchlist MIND Events",
      SerialNumber: "FMR.7905.M.01.WTLSTMND",
      Icon: { IconName: "travel_explore" } as Icon,
      Type: "Items",
      Description: "Watchlist MIND Events",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "mind-events",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Company Profile",
      SerialNumber: "FMR.7317.M.01.COPFL",
      Icon: { IconName: "domain" } as Icon,
      Type: "Items",
      Description: "Company Profile",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "company-profile",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Competitors",
      SerialNumber: "FMR.7324.M.01.STKCOMP",
      Icon: { IconName: "group" } as Icon,
      Type: "Items",
      Description: "Competitors",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "competitors",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Estimates",
      SerialNumber: "FMR.7321.M.01.STKEST",
      Icon: { IconName: "trending_up" } as Icon,
      Type: "Items",
      Description: "Estimates",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "estimates",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Market Movers",
      SerialNumber: "FMR.7001.M.01.MKTMV",
      Icon: { IconName: "timeline" } as Icon,
      Type: "Items",
      Description: "Market Movers",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "market-movers",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Market Status",
      SerialNumber: "FMR.7014.M.01.MRKTSTATUS",
      Icon: { IconName: "trending_up" } as Icon,
      Type: "Items",
      Description: "Market Status",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "market-status",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Sustainability",
      SerialNumber: "FMR.7329.M.01.STKSUS",
      Icon: { IconName: "all_inclusive" } as Icon,
      Type: "Items",
      Description: "Sustainability",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "esg",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Advanced Charting - Stocks",
      SerialNumber: "FMR.7328.M.01.STKACH",
      Icon: { IconName: "stacked_bar_chart" } as Icon,
      Type: "Items",
      Description: "Advanced Charting - Stocks",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "advanced-chart", // or fwc-advanced-chart-tools
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Events",
      SerialNumber: "FMR.7326.M.01.STKEVTS",
      Icon: { IconName: "event" } as Icon,
      Type: "Items",
      Description: "Events",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "events",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Financial Health/ Statements",
      SerialNumber: "FMR.7320.M.01.STKHLTH",
      Icon: { IconName: "health_and_safety" } as Icon,
      Type: "Items",
      Description: "Financial Health/Statements",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "financial-health",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Fin Smart Text",
      Icon: { IconName: "history_edu" } as Icon,
      Type: "Items",
      Description: "Fin Smart Text",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "smarttext",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Fin News",
      Icon: { IconName: "article" } as Icon,
      Type: "Items",
      Description: "Fin News",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "news",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Ownership",
      SerialNumber: "FMR.7322.M.01.STKOWN",
      Icon: { IconName: "assignment_ind" } as Icon,
      Type: "Items",
      Description: "Ownership",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "ownership",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Fin Quote",
      Icon: { IconName: "format_quote" } as Icon,
      Type: "Items",
      Description: "Fin Quote",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "quote",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Ratios",
      SerialNumber: "FMR.7323.M.01.STKRAT",
      Icon: { IconName: "bar_chart" } as Icon,
      Type: "Items",
      Description: "Ratios",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "ratios",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Security Search",
      SerialNumber: "FMR.7906.M.01.SECSRCH",
      Icon: { IconName: "search" } as Icon,
      Type: "Items",
      Description: "Security Search",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "search",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Chart Security Comparison",
      SerialNumber: "",
      Icon: { IconName: "bar_chart_4_bars" } as Icon,
      Type: "Items",
      Description: "Chart Security Comparison",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "chart-security-comparison",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Key Executives/ Management",
      SerialNumber: "FMR.7327.M.01.STKEXEC",
      Icon: { IconName: "supervisor_account" } as Icon,
      Type: "Items",
      Description: "Key Executives/Management",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "top-executives",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "ETF Fund Profile",
      SerialNumber: "",
      Icon: { IconName: "wallet" } as Icon,
      Type: "Items",
      Description: "ETF Fund Profile",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "etf-fund-profile",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Mutual Fund Profile",
      SerialNumber: "",
      Icon: { IconName: "paid" } as Icon,
      Type: "Items",
      Description: "Mutual Fund Profile",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "mf-profile",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "ETF Growth of 10K",
      SerialNumber: "",
      Icon: { IconName: "1k_plus" } as Icon,
      Type: "Items",
      Description: "ETF Growth of 10K",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "etf-growth-of-10k",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Market Depth",
      SerialNumber: "",
      Icon: { IconName: "currency_exchange" } as Icon,
      Type: "Items",
      Description: "Market Depth",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "market-depth",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Insights - Sector Research",
      SerialNumber: "",
      Icon: { IconName: "insights" } as Icon,
      Type: "Items",
      Description: "Insights - Sector Research",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "insights-sector-research",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Insights - Market Research",
      SerialNumber: "",
      Icon: { IconName: "analytics" } as Icon,
      Type: "Items",
      Description: "Insights - Market Research",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "insights-market-research",
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Best Ideas",
      SerialNumber: "",
      Icon: { IconName: "lightbulb" } as Icon,
      Type: "Items",
      Description: "Best Ideas",
      Category: "Market Apps",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "FinApp",
        Id: generateUID(),
        Type: "best-ideas",
      },
    },

    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Chart",
      Icon: { IconName: "add_chart" } as Icon,
      Type: "Items",
      Description: "A description for Chart",
      Category: "Containers",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        Id: generateUID(),
        __typename: "Chart",
        ChartLibrary: "AGChart",
        ChartMetadata: {},
      },
    },

    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Circular Progress",
      Icon: { IconName: "restart_alt" } as Icon,
      Type: "Items",
      Description: "A description for CircularProgress",
      Category: "Controls",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        Id: generateUID(),
        __typename: "CircularProgress",
        Variant: graphql.CircularProgressVariant.Indeterminate,
        Value: 27,
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Linear Progress",
      Icon: { IconName: "horizontal_rule" } as Icon,
      Type: "Items",
      Description: "A description for LinearProgress",
      Category: "Controls",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        Id: generateUID(),
        __typename: "LinearProgress",
        Variant: graphql.LinearProgressVariant.Indeterminate,
        Value: 27,
        ValueBuffer: 50,
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Honeycomb Chart",
      Icon: { IconName: "donut_small" } as Icon,
      Type: "Items",
      Description: "A description for HoneycombChart",
      Category: "Controls",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "HoneycombChart",
        Id: generateUID(),
        Items: [],
        ChartMetadata: {
          chart: {
            type: "sunburst",
            height: 600,
            backgroundColor: "#ffffff",
          },
          credits: {
            enabled: false,
          },
          title: {
            text: "",
          },
          subtitle: {
            text: "",
          },
          series: [
            {
              type: "sunburst",
              cursor: "pointer",
              dataLabels: {
                enabled: false,
                format: "{point.name}",
                filter: {
                  property: "innerArcLength",
                  operator: ">",
                  value: 20,
                },
                rotationMode: "circular",
                style: {
                  fontSize: "10px",
                  fontWeight: "normal",
                  color: "#ffffff",
                  textOutline: "1px rgba(0,0,0,0.5)",
                },
              },
              levels: [
                {
                  level: 1,
                  dataLabels: {
                    filter: {
                      property: "outerArcLength",
                      operator: ">",
                      value: 64,
                    },
                    style: {
                      fontSize: "12px",
                      fontWeight: "bold",
                    },
                  },
                  colorByPoint: true,
                },
                {
                  level: 2,
                  dataLabels: {
                    style: {
                      fontSize: "10px",
                    },
                  },
                },
                {
                  level: 3,
                  dataLabels: {
                    style: {
                      fontSize: "9px",
                    },
                  },
                },
              ],
              innerSize: "45%",
              size: "90%",
              borderWidth: 2,
              borderColor: "#ffffff",
              states: {
                hover: {
                  brightness: 0.1,
                },
              },
            },
          ],
          tooltip: {
            headerFormat: "",
            pointFormat: "{point.name}",
            style: {
              fontSize: "12px",
            },
            hideDelay: 0,
          },
          plotOptions: {
            sunburst: {
              borderWidth: 2,
              borderColor: "#ffffff",
            },
          },
        },
      },
    },
    {
      __typename: "LibraryItem",
      Id: generateUID(),
      Name: "Code Editor",
      Icon: { IconName: "code" },
      Type: "Items",
      Description: "A description for CodeEditor",
      Category: "Controls",
      SubCategory: "",
      InitialWidth: 5,
      InitialHeight: 25,
      Template: {
        __typename: "CodeEditor",
        Id: generateUID(),
        MultiLine: true,
        NumberOfLines: 10,
      },
    },
    // {
    //   __typename: "LibraryItem",
    //   Id: generateUID(),
    //   Name: "List",
    //   Icon: { IconName: "TableRows" },
    //   Type: "Items",
    //   Description: "A description for List",
    //   Category: "Some Category",
    //   SubCategory: "",
    //   InitialWidth: 5,
    //   InitialHeight: 25,
    //   Template: {
    //     Id: generateUID(),
    //     __typename: "List",
    //   },
    // },
  ],

  // {
  //   __typename: "Component",
  //   Id: generateUID(),
  //   Name: "AI Dialog",
  //   Icon: { IconName: "Tungsten" },
  //   Type: "Items",
  //   Description: "A description for AIDialog",
  //   Category: "Some Category",
  //   SubCategory: "",
  //   InitialWidth: 5,
  //   InitialHeight: 25,
  //   ComponentContainer: {
  //     __typename: "SimpleContainer",
  //     Id: generateUID(),
  //     UniqueName: "AIDialogContainer",
  //     Items: [
  //       {
  //         Typename: "Form",
  //         Id: generateUID(),
  //         Items: [
  //           {
  //             Id: generateUID(),
  //             __typename: "AIDialog",
  //             Label: "Label for AIDialog",
  //           },
  //         ],
  //       },
  //     ],
  //   },
  // },
  // {
  //   __typename: "Component",
  //   Id: generateUID(),
  //   Name: "Visible Menu",
  //   Icon: { IconName: "Menu" },
  //   Type: "Items",
  //   Description: "A description for VisibleMenu",
  //   Category: "Some Category",
  //   SubCategory: "",
  //   InitialWidth: 5,
  //   InitialHeight: 25,
  //   ComponentContainer: {
  //     __typename: "SimpleContainer",
  //     Id: generateUID(),
  //     UniqueName: "VisibleMenuContainer",
  //     Items: [
  //       {
  //         Typename: "Form",
  //         Id: generateUID(),
  //         Items: [
  //           {
  //             Id: generateUID(),
  //             __typename: "VisibleMenu",
  //             Label: "Label for VisibleMenu",
  //           },
  //         ],
  //       },
  //     ],
  //   },
  // },

  // {
  //   __typename: "Component",
  //   Id: generateUID(),
  //   Name: "Radio Group",
  //   Icon: { IconName: "RadioButtonChecked" },
  //   Type: "Items",
  //   Description: "A description for RadioGroup",
  //   Category: "Some Category",
  //   SubCategory: "",
  //   InitialWidth: 5,
  //   InitialHeight: 25,
  //   ComponentContainer: {
  //     __typename: "SimpleContainer",
  //     Id: generateUID(),
  //     UniqueName: "RadioGroupContainer",
  //     Items: [
  //       {
  //         Typename: "Form",
  //         Id: generateUID(),
  //         Items: [
  //           {
  //             Id: generateUID(),
  //             __typename: "RadioGroup",
  //             Label: "Label for RadioGroup",
  //           },
  //         ],
  //       },
  //     ],
  //   },
  // },

  // {
  //   __typename: "Component",
  //   Id: generateUID(),
  //   Name: "Code Editor",
  //   Icon: { IconName: "Code" },
  //   Type: "Items",
  //   Description: "A description for CodeEditor",
  //   Category: "Some Category",
  //   SubCategory: "",
  //   InitialWidth: 5,
  //   InitialHeight: 25,
  //   ComponentContainer: {
  //     __typename: "SimpleContainer",
  //     Id: generateUID(),
  //     UniqueName: "CodeEditorContainer",
  //     Items: [
  //       {
  //         Typename: "Form",
  //         Id: generateUID(),
  //         Items: [
  //           {
  //             Id: generateUID(),
  //             __typename: "CodeEditor",
  //             Label: "Label for CodeEditor",
  //           },
  //         ],
  //       },
  //     ],
  //   },
  // },
  // {
  //   __typename: "Component",
  //   Id: generateUID(),
  //   Name: "Form",
  //   Icon: { IconName: "Ballot" },
  //   Type: "Items",
  //   Description: "A description for Form",
  //   Category: "Some Category",
  //   SubCategory: "",
  //   InitialWidth: 5,
  //   InitialHeight: 25,
  //   ComponentContainer: {
  //     __typename: "SimpleContainer",
  //     Id: generateUID(),
  //     UniqueName: "FormContainer",
  //     Items: [
  //       {
  //         Typename: "Form",
  //         Id: generateUID(),
  //         Items: [
  //           {
  //             Id: generateUID(),
  //             __typename: "Form",
  //             Label: "Label for Form",
  //           },
  //         ],
  //       },
  //     ],
  //   },
  // },

  // {
  //   __typename: "Component",
  //   Id: generateUID(),
  //   Name: "Tree List",
  //   Icon: { IconName: "AccountTree" },
  //   Type: "Items",
  //   Description: "A description for TreeList",
  //   Category: "Some Category",
  //   SubCategory: "",
  //   InitialWidth: 5,
  //   InitialHeight: 25,
  //   ComponentContainer: {
  //     __typename: "SimpleContainer",
  //     Id: generateUID(),
  //     UniqueName: "TreeListContainer",
  //     Items: [
  //       {
  //         Typename: "Form",
  //         Id: generateUID(),
  //         Items: [
  //           {
  //             Id: generateUID(),
  //             __typename: "TreeList",
  //             Label: "Label for TreeList",
  //           },
  //         ],
  //       },
  //     ],
  //   },
  // },
  // {
  //   __typename: "Component",
  //   Id: generateUID(),
  //   Name: "Feed",
  //   Icon: { IconName: "ViewStream" },
  //   Type: "Items",
  //   Description: "A description for Feed",
  //   Category: "Some Category",
  //   SubCategory: "",
  //   InitialWidth: 5,
  //   InitialHeight: 25,
  //   ComponentContainer: {
  //     __typename: "SimpleContainer",
  //     Id: generateUID(),
  //     UniqueName: "FeedContainer",
  //     Items: [
  //       {
  //         Typename: "Form",
  //         Id: generateUID(),
  //         Items: [
  //           {
  //             Id: generateUID(),
  //             __typename: "Feed",
  //             Label: "Label for Feed",
  //           },
  //         ],
  //       },
  //     ],
  //   },
  // },
  // {
  //   __typename: "Component",
  //   Id: generateUID(),
  //   Name: "Repeater",
  //   Icon: { IconName: "AutoAwesomeMotion" },
  //   Type: "Applications",
  //   Description: "A description for Repeater",
  //   Category: "Some Category",
  //   SubCategory: "",
  //   InitialWidth: 5,
  //   InitialHeight: 25,
  //   ComponentContainer: {
  //     __typename: "SimpleContainer",
  //     Id: generateUID(),
  //     UniqueName: "RepeaterContainer",
  //     Items: [
  //       {
  //         Typename: "Repeater",
  //         UniqueName: generateUID(),
  //         Id: generateUID(),
  //       },
  //     ],
  //   },
  // },
  // {
  //   __typename: "Component",
  //   Id: generateUID(),
  //   Name: "IFrame",
  //   Icon: { IconName: "FilterFrames" },
  //   Type: "Items",
  //   Description: "A description for IFrame",
  //   Category: "Some Category",
  //   SubCategory: "",
  //   InitialWidth: 5,
  //   InitialHeight: 25,
  //   ComponentContainer: {
  //     __typename: "SimpleContainer",
  //     Id: generateUID(),
  //     UniqueName: "IFrameContainer",
  //     Items: [
  //       {
  //         Typename: "Form",
  //         Id: generateUID(),
  //         Items: [
  //           {
  //             Id: generateUID(),
  //             __typename: "IFrame",
  //             Label: "Label for IFrame",
  //             Source: "",
  //           } as graphql.IFrame,
  //         ],
  //       },
  //     ],
  //   },
  // },
  // {
  //   __typename: "Component",
  //   Id: generateUID(),
  //   Name: "Image",
  //   Icon: { IconName: "InsertPhoto" },
  //   Type: "Items",
  //   Description: "A description for Image",
  //   Category: "Some Category",
  //   SubCategory: "",
  //   InitialWidth: 5,
  //   InitialHeight: 25,
  //   ComponentContainer: {
  //     __typename: "SimpleContainer",
  //     Id: generateUID(),
  //     UniqueName: "ImageContainer",
  //     Items: [
  //       {
  //         Typename: "Form",
  //         Id: generateUID(),
  //         Items: [
  //           {
  //             Id: generateUID(),
  //             __typename: "Image",
  //             Label: "Label for Image",
  //             Value: "",
  //           } as graphql.Image,
  //         ],
  //       },
  //     ],
  //   },
  // },

  Actions: [
    // {
    //   Trigger: "onComponentSelected",
    //   CommandSet: {
    //     FirstCommandId: "1",
    //     ExecuteCommandsInParallel: false,
    //     Commands: [
    //       {
    //         Id: "1",
    //         Instruction: {
    //           Name: "SendMessageToChild",
    //         },
    //         Parameters: [
    //           {
    //             Name: "IFrame",
    //             Value: "EditorIFrame",
    //           },
    //           {
    //             Name: "Type",
    //             Value: "addControl",
    //           },
    //           {
    //             Name: "Bindings",
    //             Value: {
    //               Control: "Event",
    //             },
    //           },
    //           {
    //             Name: "Actions",
    //             Value: [
    //               {
    //                 Trigger: "addControl",
    //                 CommandSet: {
    //                   FirstCommandId: "1",
    //                   ExecuteCommandsInParallel: false,
    //                   Commands: [
    //                     {
    //                       Id: "1",
    //                       Instruction: {
    //                         Name: "SetState",
    //                       },
    //                       Parameters: [
    //                         {
    //                           // TODO: fix these bindings, we don't need them to do this any more
    //                           Name: "Bindings",
    //                           Value: {
    //                             "State.Container.FormApplications":
    //                               "(State.Container.FormApplications || []).concat([Event.Control.ComponentContainer])",
    //                             "State.LatestControl": "State.Container.FormApplications.slice(-1)[0]",
    //                             "State.Page.Containers": "(State.Page.Containers || []).concat(State.LatestControl)",
    //                           },
    //                         },
    //                       ],
    //                     },
    //                   ],
    //                 },
    //               },
    //             ],
    //           },
    //         ],
    //       },
    //     ],
    //   },
    // },
  ],
};
